// @flow
import * as React from "react";
import {PureComponent} from "react";
import {connect} from "react-redux";
import {
    ProposalBoxAddressInput,
    ProposalBoxAddressLabel,
} from "../../../../Address/AddressesStyle";
import PlacesAutocomplete, {geocodeByAddress, getLatLng} from "react-places-autocomplete";
import {SuggestionsFloater, SuggestionsTitle, SuggestionTitleContainer} from "./AddressSearchStyle";
import {strings} from "../../../../../config";
import AddressRow from "../../../../Address/AddressRow/AddressRow";
import MapDataSelectors from "../../../../../Store/Ducks/MapData/selectors";
import type {LatLngLiteral} from "../../../../../Utils/MapUtils";
import type {PinImage} from "../../../../Address/AddressRow/AddressRow";

const AUTOCOMPLETE_DEBOUNCE_MILLISECONDS = 200;

type OwnProps = {|
    selectSuggestedOption: ({ address: string, latlng: LatLngLiteral }) => mixed,
    searchPlaceholder: string,

    addressTitleLabel?: React.Node,
    addressField?: React.Node,
    pinImageMain?: PinImage,
    pinImageSecondary?: PinImage,
    radiusInMeters: number
|}

type State = {|
    address: string,
|}

type ConnectedProps = {|
    mapReady: boolean,
    center: LatLngLiteral,
|};

class AutocompleteSearch extends PureComponent<OwnProps & ConnectedProps, State> {

    constructor(props) {
        super(props);
        this.state = {
            address: "",
        };
    }

    handleChange = (address) => {
        this.setState({
            address: address
        });
    };

    handleSelect = (address) => {
        geocodeByAddress(address)
            .then(results => getLatLng(results[0]))
            .then(latlng => this.props.selectSuggestedOption({address, latlng}))
            .catch(error => {
            });
    };

    handleError = (error) => {
    };

    componentDidMount() {
        this.setState({address: ""});
    }

    render() {
        if (!this.props.mapReady) {
            return null;
        }

        const searchOptions = {
            location: new window.google.maps.LatLng(this.props.center.lat, this.props.center.lng),
            radius: this.props.radiusInMeters,
          }

        return (
            <PlacesAutocomplete
                value={this.state.address}
                onChange={this.handleChange}
                onSelect={this.handleSelect}
                debounce={AUTOCOMPLETE_DEBOUNCE_MILLISECONDS}
                onError={this.handleError}
                searchOptions={searchOptions}
            >
                {({getInputProps, getSuggestionItemProps, suggestions}) => {

                    return (
                        <SuggestionsFloater>
                            <AddressRow
                                addressTitleLabel={this.props.addressTitleLabel}
                                pinImageMain={this.props.pinImageMain}
                                pinImageSecondary={this.props.pinImageSecondary}
                                addressField={<ProposalBoxAddressInput {...getInputProps({
                                    placeholder: this.props.searchPlaceholder,
                                    autoFocus: true
                                })}
                                />}/>
                            <SuggestionTitleContainer>
                                <SuggestionsTitle>
                                    {strings.address_search_suggestions_title}
                                </SuggestionsTitle>
                            </SuggestionTitleContainer>
                            {suggestions.map((suggestion) =>
                                <AddressRow
                                    {...getSuggestionItemProps(suggestion)}
                                    pinImageMain={this.props.pinImageMain}
                                    addressField={
                                        <ProposalBoxAddressLabel {...getSuggestionItemProps(suggestion)}>
                                            {suggestion.description}
                                        </ProposalBoxAddressLabel>
                                    }/>
                            )}
                        </SuggestionsFloater>
                    );
                }}
            </PlacesAutocomplete>
        );
    }
}

const mapStateToProps = state => {
    return {
        mapReady: MapDataSelectors.isMapReady(state),
        center: MapDataSelectors.getMapCenter(state)
    };
};

export default connect(mapStateToProps)(AutocompleteSearch);



// WEBPACK FOOTER //
// ./src/Components/Screen/RideRequest/FreeSelection/AddressSearch/AutocompleteSearch.js